import { Company, User } from "src/app/dashboard/shared-data.service";

export type Contact = {
  uuid?: string;
  company?: Company;
  user?: User;
};

export type DataFieldType =
  | "text"
  | "list"
  | "date"
  | "phone"
  | "boolean"
  | "email"
  | "address"
  | "url"
  | "";

export enum DataFieldTypeMappingDisplay {
  "list" = "Select",
  "string" = "Text",
  "date" = "Date",
  "phone" = "Phone Number",
  "boolean" = "Boolean",
  "email" = "Email",
  "address" = "Address",
  "url" = "Url",
  "number" = "Number",
}

export type DataField = {
  type?: DataFieldType;
  key?: string;
  uuid?: string;
  name?: string;
  order?: number;
  accounting_company?: string | Company;
  field_for?: DataFieldFor;
  select_options?: any[];
};

export type DataFieldValue = {
  uuid?: string;
  content_object?: Company | Contact;
  value?: string;
  field?: DataField;
};

export enum DataFieldFor {
  "Company" = 1,
  "Contact" = 2,
}

export type CreatedDataFieldResponse = {
  new_data_field: DataField;
};

export type GetDataFieldResponse = {
  data_fields: DataField[];
};

export type DeleteDataFieldResponse = {
  message: string;
};

export type GetDataFieldValueResponse = {
  data_fields_values: DataFieldValue[];
};

export type DynamicColumn = {
  column_name?: string;
  display_label?: string;
  required: boolean;
  type?: string;
  validators?: any;
  uuid?: string;
};

export type GetDynamicColumnsResponse = {
  dynamic_columns: DynamicColumn[];
};

export type GetCustomDataDashboardDataResponse = {
  custom_data: { client_company: string; fields: { value: string }[] }[];
  columns: { field: string; header: string }[];
  total_count: number;
};
